/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
// import _ from 'lodash';

import {
  REQUEST_KANBAN_BOARDS,
  REQUEST_KANBAN_BOARD,
  REQUEST_KANBAN_BOARD_COLUMN_CELLS,
  KANBAN_BOARDS_SET_ACTIVE_BOARD,
  SET_KANBAN_PROGRESS_BAR_VALUE,
  REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ADD,
  REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVATE,
  REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVE_DONE,
  REQUEST_CACHE_STATUS,
  TOGGLE_KANBAN_COMPANY_MODAL,
  RESET_ALL_KANBAN_FILTERS,
  RESET_KANBAN_FILTER,
  UPDATE_KANBAN_FILTERS,
  SET_KANBAN_COLUMN_SORT,
} from './constants';

import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { parseVehicle } from '../Vehicles/helpers';
import { REQUEST_VEHICLE_FILTER, REQUEST_VEHICLE_FILTER_RESET, UPDATE_VEHICLE_FILTERS } from '../Vehicles/constants';

const DEFAULT_FILTER = {
  searchString: null,
  offset: 0,
  properties: [],
  sortType: null,
  order: null,
  plannable_status: null,
};
export const initialState = {
  boards: [],
  columnCells: [],
  columnDirty: {},
  toggleKanbanCompanyModal: {
    isShow: false,
    entityId: null,
    actionName: null,
  },
  activeBoardId: null,
  progressBarValues: {},
  requestQueue: [],
  requestQueueActive: null,
  filter: {
    ...DEFAULT_FILTER,
  },
  columnSort: {},
};

const parseCell = function(cell) {
  if (cell.vehicle) cell.vehicle = parseVehicle(cell.vehicle);
  return cell;
};

export const kanbanBoardReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SET_KANBAN_COLUMN_SORT:
        draft.columnSort[action.columnId] = [
          {
            sortBy: action.sortBy,
            desc: action.desc,
          },
        ];
        break;
      case KANBAN_BOARDS_SET_ACTIVE_BOARD:
        draft.activeBoardId = action.boardId;
        draft.requestQueue = [];
        break;
      case SET_KANBAN_PROGRESS_BAR_VALUE:
        draft.progressBarValues[`${action.boardId}-${action.targetType}-${action.targetId}`] = action.progress;
        break;
      case REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ADD:
        try {
          let isActive =
            draft.requestQueueActive &&
            draft.requestQueueActive.boardId == action.action.boardId &&
            draft.requestQueueActive.columnId == action.action.columnId;
          if (
            !isActive &&
            draft.requestQueue.findIndex(a => a.boardId == action.action.boardId && a.columnId == action.action.columnId) ==
              -1
          ) {
            action.startedAt = new Date().getTime();
            draft.requestQueue.push(action.action);
          }
        } catch (error) {
          //
        }
        break;
      case REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVATE:
        draft.requestQueueActive = draft.requestQueue.shift();
        break;
      case REQUEST_QUEUE_KANBAN_BOARD_COLUMN_CELLS_ACTIVE_DONE:
        draft.requestQueueActive = null;
        break;
      case TOGGLE_KANBAN_COMPANY_MODAL:
        if (draft.toggleKanbanCompanyModal?.entityId && action?.entityId != draft.toggleKanbanCompanyModal?.entityId) {
          draft.toggleKanbanCompanyModal = {
            isShow: false,
            entityId: null,
            actionName: null,
          };
        } else if (action?.entityId && action?.entityId != draft.toggleKanbanCompanyModal?.entityId) {
          draft.toggleKanbanCompanyModal = {
            isShow: true,
            entityId: action?.entityId,
            actionName: action?.actionName,
          };
        } else {
          draft.toggleKanbanCompanyModal = {
            isShow: false,
            entityId: null,
            actionName: null,
          };
        }
        break;
      case UPDATE_KANBAN_FILTERS:
        const oldFilter = draft.filter.properties?.findIndex(f => f?.key === action?.filter?.key);
        if (action?.filter?.value?.length) {
          if (oldFilter > -1) {
            draft.filter.properties[oldFilter] = { ...action.filter };
          } else {
            draft.filter.properties.push(action.filter);
          }
        } else {
          draft.filter.properties = draft.filter.properties?.filter(f => f.key !== action.filter.key);
        }
        if (action.name) {
          draft.filter[action.name] = action.value;
          //reset offset
        }
        if (action.name !== 'offset') draft.filter.offset = 0;
        break;
      case RESET_KANBAN_FILTER:
        draft.filter.properties = draft.filter.properties?.filter(f => f.key !== action.filter);
        break;
      case RESET_ALL_KANBAN_FILTERS:
        draft.filter = {
          ...DEFAULT_FILTER,
        };
        break;

      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_KANBAN_BOARDS:
            draft.boards = action.result.kanbanBoards;
            break;
          case REQUEST_KANBAN_BOARD:
            try {
              let index = draft.boards.findIndex(b => b.id == action.boardId);
              if (index === -1) draft.boards.push(action.result.kanbanBoard);
              else draft.boards[index] = action.result.kanbanBoard;
            } catch (error) {
              // eslint-disable-next-line no-debugger
              debugger;
            }
            break;
          case REQUEST_KANBAN_BOARD_COLUMN_CELLS:
            draft.columnCells[action.columnId] = action.result?.cells?.map(parseCell);
            draft.columnDirty[action.columnId] = action.result?.dirty;
            break;
          case REQUEST_CACHE_STATUS:
            draft.cacheStatus = action.result.status;
            break;
        }
    }
  });
